<script lang="ts">
  import app from '#app/app'
  import { commands } from '#app/radio'
  import Modal from '#components/modal.svelte'
  import ItemShow from '#inventory/components/item_show.svelte'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'

  let {
    item,
    pathnameAfterClosingModal,
    autodestroyComponent,
  }: {
    item: SerializedItemWithUserData
    pathnameAfterClosingModal?: string
    autodestroyComponent?: () => void
  } = $props()

  function close () {
    if (pathnameAfterClosingModal) {
      app.navigate(pathnameAfterClosingModal, { preventScrollTop: true })
      autodestroyComponent()
    } else {
      commands.execute('show:inventory:user', item.owner)
    }
  }
</script>

<Modal size="large" on:closeModal={close}>
  <!-- eslint-disable-next-line svelte/no-unused-svelte-ignore -->
  <!-- svelte-ignore ownership_invalid_binding -->
  <ItemShow bind:item />
</Modal>
